import { ModelParameters } from "@/components/ModelParameters";
import { PromptBlueprint } from "@/types";

interface ModelSummaryChipProps {
  isPromptChat: boolean;
  readonly: boolean;
  promptData: Partial<PromptBlueprint> | null | undefined;
  onModeChange: (isChat: boolean) => void;
  onUpdate: (promptData: Partial<PromptBlueprint>) => void;
  controlledOpen?: boolean;
  onControlledOpenChange?: (open: boolean) => void;
  triggerClassName?: string;
  functionDialogTriggerVariant?: "default" | "menu-item";
}

export default function ModelSummaryChip({
  isPromptChat,
  readonly,
  promptData,
  onModeChange,
  onUpdate,
  controlledOpen,
  onControlledOpenChange,
  triggerClassName = "h-8 max-w-[240px] justify-start rounded-full px-2.5 text-gray-700 transition-colors hover:bg-gray-100",
  functionDialogTriggerVariant,
}: ModelSummaryChipProps) {
  return (
    <ModelParameters
      className="items-center"
      isPromptChat={isPromptChat}
      onModeChange={onModeChange}
      promptData={promptData ?? undefined}
      readonly={readonly}
      triggerClassName={triggerClassName}
      triggerLabelClassName="truncate"
      buttonSize="sm"
      showIcon
      showTooltip={false}
      onUpdate={onUpdate}
      controlledOpen={controlledOpen}
      onControlledOpenChange={onControlledOpenChange}
      functionDialogTriggerVariant={functionDialogTriggerVariant}
    />
  );
}
